import * as React from "react";
import { Injectable } from "bwtk";
import { IFormProps, IFormState, IFormValues, IFormErrors } from "../Models/FeedbackForm";
import { getFeedbackData } from "../Utils/HelperFunctions";
import { FeedbackFormBell } from "./FeedbackFormBell";
import { FeedbackFormLucky } from "./FeedbackFormLucky";
import { injectIntl } from "react-intl";

declare const grecaptcha: any;
declare const setCaptchaId: any;
declare const setCaptchaToken: any;
declare const setCheckV2HighRisk: any;
declare const toggleBackButton: any;
declare const scrollToTop: any;

@Injectable
class FeedbackForm extends React.Component<IFormProps, IFormState> {

  private tooltipInstance: any;
  private feedbackSubjectRef: React.RefObject<HTMLSelectElement>;
  private commentsRef: React.RefObject<HTMLTextAreaElement>;
  private alternateFormatDocumentsRef: React.RefObject<HTMLInputElement>;
  private requestAlternateFormatTypesRef: React.RefObject<HTMLInputElement>;
  private brailleFormatTypeRef: React.RefObject<HTMLInputElement>;
  private electronicFormatTypeRef: React.RefObject<HTMLInputElement>;
  private audioFormatTypeRef: React.RefObject<HTMLInputElement>;
  private audioDeliveryTypeRef: React.RefObject<HTMLInputElement>;
  private otherFormatTypeRef: React.RefObject<HTMLInputElement>;
  private RAF_fullNameRef: React.RefObject<HTMLInputElement>;
  private RAF_emailRef: React.RefObject<HTMLInputElement>;
  private RAF_telephoneRef: React.RefObject<HTMLInputElement>;
  private RAF_streetAddRef: React.RefObject<HTMLInputElement>;
  private RAF_cityRef: React.RefObject<HTMLInputElement>;
  private RAF_provinceRef: React.RefObject<HTMLSelectElement>;
  private RAF_countryRef: React.RefObject<HTMLSelectElement>;
  private RAF_postalCodeRef: React.RefObject<HTMLInputElement>;
  private emailAddRef: React.RefObject<HTMLInputElement>;
  private telephoneRef: React.RefObject<HTMLInputElement>;
  private ipRelayRef: React.RefObject<HTMLInputElement>;
  private ttyNumberRef: React.RefObject<HTMLInputElement>;
  private videoRelayServiceRef: React.RefObject<HTMLInputElement>;
  private initFormValues: IFormValues = { brand: this.props.brand, feedbackSubject: "", comments: "", preferredLanguage: this.props.lang === "en" ? "English" : "French", contactMethod: "Email", alternateFormatDocuments: [], requestAlternateFormatTypes: "", brailleFormatType: [], etextFormatType: [], electronicFormatType: [], electronicDeliveryType: [], audioFormatType: [], audioDeliveryType: [], otherFormatType: "", RAF_fullName: "", RAF_email: "", RAF_telephone: "", RAF_streetAdd: "", RAF_aptNo: "", RAF_city: "", RAF_province: "", RAF_country: "", RAF_postalCode: "", emailAdd: "", telephone: "", ipRelay: "", ttyNumber: "", videoRelayService: "", fullName: ""};
  private initFormErrors: IFormErrors = { brand: false, feedbackSubject: false, preferredLanguage: false, contactMethod: false, alternateFormatDocuments: false, requestAlternateFormatTypes: false, comments: false, brailleFormatType: false, etextFormatType: false, electronicFormatType: false, electronicDeliveryType: false, audioFormatType: false, audioDeliveryType: false, otherFormatType: false, RAF_fullName: false, RAF_email: false, RAF_telephone: false, RAF_streetAdd: false, RAF_aptNo: false, RAF_city: false, RAF_province: false, RAF_country: false, RAF_postalCode: false, emailAdd: false, telephone: false, ipRelay: false, ttyNumber: false, videoRelayService: false, fullName: false};
  private initFormValidFields: IFormErrors = { brand: true, feedbackSubject: false, preferredLanguage: true, contactMethod: true, alternateFormatDocuments: true, requestAlternateFormatTypes: true, comments: false, brailleFormatType: true, etextFormatType: true, electronicFormatType: true, electronicDeliveryType: true, audioFormatType: true, audioDeliveryType: true, otherFormatType: true, RAF_fullName: true, RAF_email: true, RAF_telephone: true, RAF_streetAdd: true, RAF_aptNo: true, RAF_city: true, RAF_province: true, RAF_country: true, RAF_postalCode: true, emailAdd: false, telephone: true, ipRelay: true, ttyNumber: true, videoRelayService: true, fullName: true };

  constructor(props: IFormProps) {
    super(props);

    this.state = {formValues: this.initFormValues, formErrors: this.initFormErrors, formValidFields: this.initFormValidFields, feedbackSubmitSuccess: false, feedbackSubmitFailure: false, isVerified: false, isSubmitting: false, isRecaptchaEnterpriseHighRisk: false, isRecaptchaV2Rendered: false};

    this.feedbackSubjectRef = React.createRef();
    this.commentsRef = React.createRef();
    this.alternateFormatDocumentsRef  = React.createRef();
    this.requestAlternateFormatTypesRef = React.createRef();
    this.brailleFormatTypeRef = React.createRef();
    this.electronicFormatTypeRef = React.createRef();
    this.audioFormatTypeRef = React.createRef();
    this.audioDeliveryTypeRef = React.createRef();
    this.otherFormatTypeRef = React.createRef();
    this.RAF_fullNameRef = React.createRef();
    this.RAF_emailRef = React.createRef();
    this.RAF_telephoneRef = React.createRef();
    this.RAF_streetAddRef = React.createRef();
    this.RAF_cityRef = React.createRef();
    this.RAF_provinceRef = React.createRef();
    this.RAF_countryRef = React.createRef();
    this.RAF_postalCodeRef = React.createRef();
    this.emailAddRef = React.createRef();
    this.telephoneRef = React.createRef();
    this.ipRelayRef = React.createRef();
    this.ttyNumberRef = React.createRef();
    this.videoRelayServiceRef = React.createRef();
  }

  setTooltipInstance = (e: any) => {
    this.tooltipInstance = e;
  }

  handleChange = (e: React.SyntheticEvent<HTMLInputElement>) => {
    const {name, value, type, checked} = e.currentTarget;
    this.validateSelectField(name, value, type, checked);
  }

  handleBlur = (e: React.SyntheticEvent<HTMLInputElement>) => {
    const {name, value} = e.currentTarget;
    this.validateTextField(name, value);
  }

  validateTextField = (name: string, value: any) => {
    let hasError = false;

    switch (name) {
      case "emailAdd":
        if ((this.state.formValues.contactMethod === "Email" || this.state.formValues.contactMethod === "Email_and_Telephone") && !value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
            hasError = true;
        }
        break;
      case "telephone":
        if ((this.state.formValues.contactMethod === "Telephone" || this.state.formValues.contactMethod === "Email_and_Telephone") && !value.match(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im)) {
            hasError = true;
        }
        break;
      case "ipRelay":
        if (this.state.formValues.contactMethod === "IP_relay" && !value.match(/^\d{9}$/)) {
            hasError = true;
        }
        break;
      case "ttyNumber":
        if (this.state.formValues.contactMethod === "TTY" && !value.match(/^\d{10}$/)) {
            hasError = true;
        }
        break;
      case "videoRelayService":
        if (this.state.formValues.contactMethod === "Video_relay_service" && !value.match(/^\d{10}$/)) {
            hasError = true;
        }
        break;
      case "otherFormatType":
        if (this.state.formValues.feedbackSubject === "Request_alternate_format" && this.state.formValues.requestAlternateFormatTypes === "Other" && value === "") {
            hasError = true;
        }
        break;
      case "RAF_email":
        if (!value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
            hasError = true;
        }
        break;
      case "RAF_telephone":
        if (!value.match(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im)) {
            hasError = true;
        }
        break;
      case "RAF_postalCode":
        if (!value.match(/^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/i)) {
            hasError = true;
        }
        break;
      case "RAF_fullName":
        if (!value.match(/^[A-Za-z àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ"\)\(.-]([-"]?[A-Za-z àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ"\)\(.-]+)*( [A-Za-z àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ"\)\(.-]([-"]?[A-Za-z àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ"\)\(.-]+)*)+$/)) {
            hasError = true;
        }
        break;
      case "RAF_streetAdd":
      case "RAF_city":
      case "RAF_province":
      case "RAF_country":
      case "feedbackSubject":
        if (value === "") {
            hasError = true;
        }
        break;
      case "comments":
        if (value === "" && this.state.formValues.feedbackSubject !== "Request_alternate_format") {
            hasError = true;
        }
        break;
      default:
        break;
    }

    this.setState({
        formValues: {...this.state.formValues, [name]: value},
        formErrors: {...this.state.formErrors, [name]: hasError},
        formValidFields: {...this.state.formValidFields, [name]: !hasError} });
  }

  validateSelectField = (name: any, value: any, type: any, checked: any) => {
    let hasError = false;
    let hasSetState = false;

    switch (name) {
      case "feedbackSubject":
        hasError = value.length > 0 ? false : true;
        hasSetState = true;
        if (value !== "Request_alternate_format") {
            let isEmailValid = ((this.state.formValues.contactMethod === "Email" || this.state.formValues.contactMethod === "Email_and_Telephone") && this.state.formValues.emailAdd === "") ? false : true;
            let isPhoneValid = ((this.state.formValues.contactMethod === "Telephone" || this.state.formValues.contactMethod === "Email_and_Telephone") && this.state.formValues.telephone === "") ? false : true;
            if (this.state.formValues.feedbackSubject === "Request_alternate_format") {
                this.setState({
                    formValues: {...this.state.formValues, [name]: value, alternateFormatDocuments: [], requestAlternateFormatTypes: "", brailleFormatType: [], etextFormatType: [], electronicFormatType: [], electronicDeliveryType: [], audioFormatType: [], audioDeliveryType: [], otherFormatType: "", RAF_fullName: "", RAF_email: "", RAF_telephone: "", RAF_streetAdd: "", RAF_aptNo: "", RAF_city: "", RAF_province: "", RAF_country: "", RAF_postalCode: ""},
                    formErrors: {...this.state.formErrors, [name]: hasError, comments: false, alternateFormatDocuments: false, requestAlternateFormatTypes: false, brailleFormatType: false, etextFormatType: false, electronicFormatType: false, electronicDeliveryType: false, audioFormatType: false, audioDeliveryType: false, otherFormatType: false, RAF_fullName: false, RAF_email: false, RAF_telephone: false, RAF_streetAdd: false, RAF_aptNo: false, RAF_city: false, RAF_province: false, RAF_country: false, RAF_postalCode: false},
                    formValidFields: {...this.state.formValidFields, [name]: !hasError, comments: false, emailAdd: isEmailValid, telephone: isPhoneValid, alternateFormatDocuments: true, requestAlternateFormatTypes: true, brailleFormatType: true, etextFormatType: true, electronicFormatType: true, electronicDeliveryType: true, audioFormatType: true, audioDeliveryType: true, otherFormatType: true, RAF_fullName: true, RAF_email: true, RAF_telephone: true, RAF_streetAdd: true, RAF_aptNo: true, RAF_city: true, RAF_province: true, RAF_country: true, RAF_postalCode: true}
                    });
            }
            else {
                this.setState({
                    formValues: {...this.state.formValues, [name]: value, alternateFormatDocuments: [], requestAlternateFormatTypes: "", brailleFormatType: [], etextFormatType: [], electronicFormatType: [], electronicDeliveryType: [], audioFormatType: [], audioDeliveryType: [], otherFormatType: "", RAF_fullName: "", RAF_email: "", RAF_telephone: "", RAF_streetAdd: "", RAF_aptNo: "", RAF_city: "", RAF_province: "", RAF_country: "", RAF_postalCode: ""},
                    formErrors: {...this.state.formErrors, [name]: hasError, alternateFormatDocuments: false, requestAlternateFormatTypes: false, brailleFormatType: false, etextFormatType: false, electronicFormatType: false, electronicDeliveryType: false, audioFormatType: false, audioDeliveryType: false, otherFormatType: false, RAF_fullName: false, RAF_email: false, RAF_telephone: false, RAF_streetAdd: false, RAF_aptNo: false, RAF_city: false, RAF_province: false, RAF_country: false, RAF_postalCode: false},
                    formValidFields: {...this.state.formValidFields, [name]: !hasError, emailAdd: isEmailValid, telephone: isPhoneValid, alternateFormatDocuments: true, requestAlternateFormatTypes: true, brailleFormatType: true, etextFormatType: true, electronicFormatType: true, electronicDeliveryType: true, audioFormatType: true, audioDeliveryType: true, otherFormatType: true, RAF_fullName: true, RAF_email: true, RAF_telephone: true, RAF_streetAdd: true, RAF_aptNo: true, RAF_city: true, RAF_province: true, RAF_country: true, RAF_postalCode: true}
                    });
            }
        }
        else {
            this.setState({
                formValues: {...this.state.formValues, [name]: value, comments: "", emailAdd: "", telephone: "", fullName: "", RAF_country: "Canada"},
                formErrors: {...this.state.formErrors, [name]: hasError, comments: false, emailAdd: false, telephone: false, fullName: false},
                formValidFields: {...this.state.formValidFields, [name]: !hasError, comments: true, emailAdd: true, telephone: true, fullName: true, alternateFormatDocuments: false, requestAlternateFormatTypes: false, RAF_fullName: false, RAF_email: false, RAF_telephone: false, RAF_streetAdd: false, RAF_city: false, RAF_province: false, RAF_country: true, RAF_postalCode: false}
                });
        }
        break;
    case "documentDescriptionOfTheFeedbackProcess":
        hasSetState = true;
        if (checked) {
            let alternateFormatDocumentsValue = this.state.formValues.alternateFormatDocuments.concat("Description_of_the_feedback_process");
            this.setState({
                formValues: {...this.state.formValues, alternateFormatDocuments: alternateFormatDocumentsValue},
                formErrors: {...this.state.formErrors, alternateFormatDocuments: hasError},
                formValidFields: {...this.state.formValidFields, alternateFormatDocuments: !hasError} });
        }
        else {
            let alternateFormatDocumentsValue = this.state.formValues.alternateFormatDocuments.filter((item) => { return item !== "Description_of_the_feedback_process"; });
            if (alternateFormatDocumentsValue.length === 0) {
                hasError = true;
            }
            this.setState({
                formValues: {...this.state.formValues, alternateFormatDocuments: alternateFormatDocumentsValue},
                formErrors: {...this.state.formErrors, alternateFormatDocuments: hasError},
                formValidFields: {...this.state.formValidFields, alternateFormatDocuments: !hasError} });
        }
        break;
    case "documentTheAccessibilityPlan":
        hasSetState = true;
        if (checked) {
            let alternateFormatDocumentsValue = this.state.formValues.alternateFormatDocuments.concat("The_accessibility_plan");
            this.setState({
                formValues: {...this.state.formValues, alternateFormatDocuments: alternateFormatDocumentsValue},
                formErrors: {...this.state.formErrors, alternateFormatDocuments: hasError},
                formValidFields: {...this.state.formValidFields, alternateFormatDocuments: !hasError} });
        }
        else {
            let alternateFormatDocumentsValue = this.state.formValues.alternateFormatDocuments.filter((item) => { return item !== "The_accessibility_plan"; });
            if (alternateFormatDocumentsValue.length === 0) {
                hasError = true;
            }
            this.setState({
                formValues: {...this.state.formValues, alternateFormatDocuments: alternateFormatDocumentsValue},
                formErrors: {...this.state.formErrors, alternateFormatDocuments: hasError},
                formValidFields: {...this.state.formValidFields, alternateFormatDocuments: !hasError} });
        }
        break;
    case "documentTheAccessibilityProgressReport":
        hasSetState = true;
        if (checked) {
            let alternateFormatDocumentsValue = this.state.formValues.alternateFormatDocuments.concat("The_accessibility_progress_report");
            this.setState({
                formValues: {...this.state.formValues, alternateFormatDocuments: alternateFormatDocumentsValue},
                formErrors: {...this.state.formErrors, alternateFormatDocuments: hasError},
                formValidFields: {...this.state.formValidFields, alternateFormatDocuments: !hasError} });
        }
        else {
            let alternateFormatDocumentsValue = this.state.formValues.alternateFormatDocuments.filter((item) => { return item !== "The_accessibility_progress_report"; });
            if (alternateFormatDocumentsValue.length === 0) {
                hasError = true;
            }
            this.setState({
                formValues: {...this.state.formValues, alternateFormatDocuments: alternateFormatDocumentsValue},
                formErrors: {...this.state.formErrors, alternateFormatDocuments: hasError},
                formValidFields: {...this.state.formValidFields, alternateFormatDocuments: !hasError} });
        }
        break;
    case "requestAlternateFormatTypes":
        hasError = value.length > 0 ? false : true;
        hasSetState = true;
        if (value !== "Electronic") {
            this.setState({
                formValues: {...this.state.formValues, [name]: value, brailleFormatType: [], etextFormatType: [], electronicFormatType: [], electronicDeliveryType: [], audioFormatType: [], audioDeliveryType: [], otherFormatType: ""},
                formErrors: {...this.state.formErrors, [name]: hasError, requestAlternateFormatTypes: false, brailleFormatType: false, etextFormatType: false, electronicFormatType: false, electronicDeliveryType: false, audioFormatType: false, audioDeliveryType: false, otherFormatType: false, RAF_fullName: false, RAF_email: false, RAF_telephone: false, RAF_streetAdd: false, RAF_aptNo: false, RAF_city: false, RAF_province: false, RAF_country: false, RAF_postalCode: false},
                formValidFields: {...this.state.formValidFields, [name]: !hasError, requestAlternateFormatTypes: true, brailleFormatType: true, etextFormatType: true, electronicFormatType: true, electronicDeliveryType: true, audioFormatType: true, audioDeliveryType: true, otherFormatType: true}
                });
        }
        else {
            this.setState({
                formValues: {...this.state.formValues, [name]: value, brailleFormatType: [], etextFormatType: [], electronicFormatType: [], electronicDeliveryType: [], audioFormatType: [], audioDeliveryType: [], otherFormatType: ""},
                formErrors: {...this.state.formErrors, [name]: hasError, requestAlternateFormatTypes: false, brailleFormatType: false, etextFormatType: false, electronicFormatType: false, electronicDeliveryType: false, audioFormatType: false, audioDeliveryType: false, otherFormatType: false, RAF_fullName: false, RAF_email: false, RAF_telephone: false, RAF_streetAdd: false, RAF_aptNo: false, RAF_city: false, RAF_province: false, RAF_country: false, RAF_postalCode: false},
                formValidFields: {...this.state.formValidFields, [name]: !hasError, requestAlternateFormatTypes: true, brailleFormatType: true, etextFormatType: true, electronicFormatType: true, electronicDeliveryType: true, audioFormatType: true, audioDeliveryType: true, otherFormatType: true, RAF_streetAdd: true, RAF_city: true, RAF_province: true, RAF_country: true, RAF_postalCode: true}
                });
        }

        break;
    case "RAF_province":
    case "RAF_country":
        hasError = value.length > 0 ? false : true;
        break;
    case "contactMethod":
        if (value === "Email") {
            if (this.state.formValues.feedbackSubject !== "Request_alternate_format") {
                hasSetState = true;
                this.setState({
                    formValues: {...this.state.formValues, [name]: value, telephone: "", ipRelay: "", ttyNumber: "", videoRelayService: ""},
                    formErrors: {...this.state.formErrors, [name]: hasError, emailAdd: false, telephone: false, ipRelay: false, ttyNumber: false, videoRelayService: false},
                    formValidFields: {...this.state.formValidFields, [name]: !hasError, emailAdd: false, telephone: true, ipRelay: true, ttyNumber: true, videoRelayService: true}
                    });
            }
            else {
                hasSetState = true;
                this.setState({
                    formValues: {...this.state.formValues, [name]: value, telephone: "", ipRelay: "", ttyNumber: "", videoRelayService: ""},
                    formErrors: {...this.state.formErrors, [name]: hasError, emailAdd: false, telephone: false, ipRelay: false, ttyNumber: false, videoRelayService: false},
                    formValidFields: {...this.state.formValidFields, [name]: !hasError, emailAdd: true, telephone: true, ipRelay: true, ttyNumber: true, videoRelayService: true}
                    });
            }
        }
        else if (value === "Telephone") {
            if (this.state.formValues.feedbackSubject !== "Request_alternate_format") {
                hasSetState = true;
                this.setState({
                    formValues: {...this.state.formValues, [name]: value, emailAdd: "", ipRelay: "", ttyNumber: "", videoRelayService: ""},
                    formErrors: {...this.state.formErrors, [name]: hasError, emailAdd: false, telephone: false, ipRelay: false, ttyNumber: false, videoRelayService: false},
                    formValidFields: {...this.state.formValidFields, [name]: !hasError, telephone: false, emailAdd: true, ipRelay: true, ttyNumber: true, videoRelayService: true}
                    });
            }
            else {
                hasSetState = true;
                this.setState({
                    formValues: {...this.state.formValues, [name]: value, emailAdd: "", ipRelay: "", ttyNumber: "", videoRelayService: ""},
                    formErrors: {...this.state.formErrors, [name]: hasError, emailAdd: false, telephone: false, ipRelay: false, ttyNumber: false, videoRelayService: false},
                    formValidFields: {...this.state.formValidFields, [name]: !hasError, telephone: true, emailAdd: true, ipRelay: true, ttyNumber: true, videoRelayService: true}
                    });
            }
        }
        else if (value === "Email_and_Telephone") {
            if (this.state.formValues.feedbackSubject !== "Request_alternate_format") {
                hasSetState = true;
                this.setState({
                    formValues: {...this.state.formValues, [name]: type === "checkbox" ? checked : value, ipRelay: "", ttyNumber: "", videoRelayService: ""},
                    formErrors: {...this.state.formErrors, [name]: hasError, emailAdd: false, telephone: false, ipRelay: false, ttyNumber: false, videoRelayService: false},
                    formValidFields: {...this.state.formValidFields, [name]: !hasError, emailAdd: false, telephone: false, ipRelay: true, ttyNumber: true, videoRelayService: true}
                    });
            }
            else {
                hasSetState = true;
                this.setState({
                    formValues: {...this.state.formValues, [name]: type === "checkbox" ? checked : value, ipRelay: "", ttyNumber: "", videoRelayService: ""},
                    formErrors: {...this.state.formErrors, [name]: hasError, emailAdd: false, telephone: false, ipRelay: false, ttyNumber: false, videoRelayService: false},
                    formValidFields: {...this.state.formValidFields, [name]: !hasError, emailAdd: true, telephone: true, ipRelay: true, ttyNumber: true, videoRelayService: true}
                    });
            }
        }
        else if (value === "IP_relay") {
            hasSetState = true;
            this.setState({
                formValues: {...this.state.formValues, [name]: value, emailAdd: "", telephone: "", ttyNumber: "", videoRelayService: ""},
                formErrors: {...this.state.formErrors, [name]: hasError, emailAdd: false, telephone: false, ttyNumber: false, videoRelayService: false},
                formValidFields: {...this.state.formValidFields, [name]: !hasError, ipRelay: false, emailAdd: true, telephone: true, ttyNumber: true, videoRelayService: true}
                });
        }
        else if (value === "TTY") {
            hasSetState = true;
            this.setState({
                formValues: {...this.state.formValues, [name]: value, emailAdd: "", telephone: "", ipRelay: "", videoRelayService: ""},
                formErrors: {...this.state.formErrors, [name]: hasError, emailAdd: false, telephone: false, ipRelay: false, videoRelayService: false},
                formValidFields: {...this.state.formValidFields, [name]: !hasError, ttyNumber: false, emailAdd: true, telephone: true, ipRelay: true, videoRelayService: true}
                });
        }
        else if (value === "Video_relay_service") {
            hasSetState = true;
            this.setState({
                formValues: {...this.state.formValues, [name]: value, emailAdd: "", telephone: "", ipRelay: "", ttyNumber: ""},
                formErrors: {...this.state.formErrors, [name]: hasError, emailAdd: false, telephone: false, ipRelay: false, ttyNumber: false},
                formValidFields: {...this.state.formValidFields, [name]: !hasError, videoRelayService: false, emailAdd: true, telephone: true, ipRelay: true, ttyNumber: true}
                });
        }
        else if (value === "None") {
            hasSetState = true;
            this.setState({
                formValues: {...this.state.formValues, [name]: value, emailAdd: "", telephone: "", ipRelay: "", ttyNumber: "", videoRelayService: ""},
                formErrors: {...this.state.formErrors, [name]: hasError, preferredLanguage: false, emailAdd: false, telephone: false, ipRelay: false, ttyNumber: false, videoRelayService: false},
                formValidFields: {...this.state.formValidFields, [name]: !hasError, preferredLanguage: true, emailAdd: true, telephone: true, ipRelay: true, ttyNumber: true, videoRelayService: true}
                });
        }
        break;
      case "brailleFormatType1":
        hasSetState = true;
        if (checked) {
            let brailleFormatTypeValue = this.state.formValues.brailleFormatType.concat("Braille_1");
            this.setState({
                formValues: {...this.state.formValues, brailleFormatType: brailleFormatTypeValue},
                formErrors: {...this.state.formErrors, brailleFormatType: hasError},
                formValidFields: {...this.state.formValidFields, brailleFormatType: !hasError} });
        }
        else {
            let brailleFormatTypeValue = this.state.formValues.brailleFormatType.filter((item) => { return item !== "Braille_1"; });
            if (brailleFormatTypeValue.length === 0) {
                hasError = true;
            }
            this.setState({
                formValues: {...this.state.formValues, brailleFormatType: brailleFormatTypeValue},
                formErrors: {...this.state.formErrors, brailleFormatType: hasError},
                formValidFields: {...this.state.formValidFields, brailleFormatType: !hasError} });
        }
        break;
    case "brailleFormatType2":
        hasSetState = true;
        if (checked) {
            let brailleFormatTypeValue = this.state.formValues.brailleFormatType.concat("Braille_2");
            this.setState({
                formValues: {...this.state.formValues, brailleFormatType: brailleFormatTypeValue},
                formErrors: {...this.state.formErrors, brailleFormatType: hasError},
                formValidFields: {...this.state.formValidFields, brailleFormatType: !hasError} });
        }
        else {
            let brailleFormatTypeValue = this.state.formValues.brailleFormatType.filter((item) => { return item !== "Braille_2"; });
            if (brailleFormatTypeValue.length === 0) {
                hasError = true;
            }
            this.setState({
                formValues: {...this.state.formValues, brailleFormatType: brailleFormatTypeValue},
                formErrors: {...this.state.formErrors, brailleFormatType: hasError},
                formValidFields: {...this.state.formValidFields, brailleFormatType: !hasError} });
        }
        break;
    case "electronicFormatTypeWord":
        hasSetState = true;
        if (checked) {
            let electronicFormatTypeValue = this.state.formValues.electronicFormatType.concat("Microsoft_Word");
            this.setState({
                formValues: {...this.state.formValues, electronicFormatType: electronicFormatTypeValue},
                formErrors: {...this.state.formErrors, electronicFormatType: hasError},
                formValidFields: {...this.state.formValidFields, electronicFormatType: !hasError} });
        }
        else {
            let electronicFormatTypeValue = this.state.formValues.electronicFormatType.filter((item) => { return item !== "Microsoft_Word"; });
            if (electronicFormatTypeValue.length === 0) {
                hasError = true;
            }
            this.setState({
                formValues: {...this.state.formValues, electronicFormatType: electronicFormatTypeValue},
                formErrors: {...this.state.formErrors, electronicFormatType: hasError},
                formValidFields: {...this.state.formValidFields, electronicFormatType: !hasError} });
        }
        break;
    case "electronicFormatTypePDF":
        hasSetState = true;
        if (checked) {
            let electronicFormatTypeValue = this.state.formValues.electronicFormatType.concat("PDF");
            this.setState({
                formValues: {...this.state.formValues, electronicFormatType: electronicFormatTypeValue},
                formErrors: {...this.state.formErrors, electronicFormatType: hasError},
                formValidFields: {...this.state.formValidFields, electronicFormatType: !hasError} });
        }
        else {
            let electronicFormatTypeValue = this.state.formValues.electronicFormatType.filter((item) => { return item !== "PDF"; });
            if (electronicFormatTypeValue.length === 0) {
                hasError = true;
            }
            this.setState({
                formValues: {...this.state.formValues, electronicFormatType: electronicFormatTypeValue},
                formErrors: {...this.state.formErrors, electronicFormatType: hasError},
                formValidFields: {...this.state.formValidFields, electronicFormatType: !hasError} });
        }
        break;
    case "electronicFormatTypeTXT":
        hasSetState = true;
        if (checked) {
            let electronicFormatTypeValue = this.state.formValues.electronicFormatType.concat("TXT");
            this.setState({
                formValues: {...this.state.formValues, electronicFormatType: electronicFormatTypeValue},
                formErrors: {...this.state.formErrors, electronicFormatType: hasError},
                formValidFields: {...this.state.formValidFields, electronicFormatType: !hasError} });
        }
        else {
            let electronicFormatTypeValue = this.state.formValues.electronicFormatType.filter((item) => { return item !== "TXT"; });
            if (electronicFormatTypeValue.length === 0) {
                hasError = true;
            }
            this.setState({
                formValues: {...this.state.formValues, electronicFormatType: electronicFormatTypeValue},
                formErrors: {...this.state.formErrors, electronicFormatType: hasError},
                formValidFields: {...this.state.formValidFields, electronicFormatType: !hasError} });
        }
        break;
    case "audioFormatTypeWAV":
        hasSetState = true;
        if (checked) {
            let audioFormatTypeValue = this.state.formValues.audioFormatType.concat("WAV");
            this.setState({
                formValues: {...this.state.formValues, audioFormatType: audioFormatTypeValue},
                formErrors: {...this.state.formErrors, audioFormatType: hasError},
                formValidFields: {...this.state.formValidFields, audioFormatType: !hasError} });
        }
        else {
            let audioFormatTypeValue = this.state.formValues.audioFormatType.filter((item) => { return item !== "WAV"; });
            if (audioFormatTypeValue.length === 0) {
                hasError = true;
            }
            this.setState({
                formValues: {...this.state.formValues, audioFormatType: audioFormatTypeValue},
                formErrors: {...this.state.formErrors, audioFormatType: hasError},
                formValidFields: {...this.state.formValidFields, audioFormatType: !hasError} });
        }
        break;
    case "audioFormatTypeMP3":
        hasSetState = true;
        if (checked) {
            let audioFormatTypeValue = this.state.formValues.audioFormatType.concat("MP3");
            this.setState({
                formValues: {...this.state.formValues, audioFormatType: audioFormatTypeValue},
                formErrors: {...this.state.formErrors, audioFormatType: hasError},
                formValidFields: {...this.state.formValidFields, audioFormatType: !hasError} });
        }
        else {
            let audioFormatTypeValue = this.state.formValues.audioFormatType.filter((item) => { return item !== "MP3"; });
            if (audioFormatTypeValue.length === 0) {
                hasError = true;
            }
            this.setState({
                formValues: {...this.state.formValues, audioFormatType: audioFormatTypeValue},
                formErrors: {...this.state.formErrors, audioFormatType: hasError},
                formValidFields: {...this.state.formValidFields, audioFormatType: !hasError} });
        }
        break;
    case "audioDeliveryTypeCDROM":
        hasSetState = true;
        if (checked) {
            let audioDeliveryTypeValue = this.state.formValues.audioDeliveryType.concat("CD_ROM");
            this.setState({
                formValues: {...this.state.formValues, audioDeliveryType: audioDeliveryTypeValue},
                formErrors: {...this.state.formErrors, audioDeliveryType: hasError},
                formValidFields: {...this.state.formValidFields, audioDeliveryType: !hasError} });
        }
        else {
            let audioDeliveryTypeValue = this.state.formValues.audioDeliveryType.filter((item) => { return item !== "CD_ROM"; });
            if (audioDeliveryTypeValue.length === 0) {
                hasError = true;
            }
            this.setState({
                formValues: {...this.state.formValues, audioDeliveryType: audioDeliveryTypeValue},
                formErrors: {...this.state.formErrors, audioDeliveryType: hasError},
                formValidFields: {...this.state.formValidFields, audioDeliveryType: !hasError} });
        }
        break;
    case "audioDeliveryTypeUSB":
        hasSetState = true;
        if (checked) {
            let audioDeliveryTypeValue = this.state.formValues.audioDeliveryType.concat("USB");
            this.setState({
                formValues: {...this.state.formValues, audioDeliveryType: audioDeliveryTypeValue},
                formErrors: {...this.state.formErrors, audioDeliveryType: hasError},
                formValidFields: {...this.state.formValidFields, audioDeliveryType: !hasError} });
        }
        else {
            let audioDeliveryTypeValue = this.state.formValues.audioDeliveryType.filter((item) => { return item !== "USB"; });
            if (audioDeliveryTypeValue.length === 0) {
                hasError = true;
            }
            this.setState({
                formValues: {...this.state.formValues, audioDeliveryType: audioDeliveryTypeValue},
                formErrors: {...this.state.formErrors, audioDeliveryType: hasError},
                formValidFields: {...this.state.formValidFields, audioDeliveryType: !hasError} });
        }
        break;
    default:
        break;
    }

    if (!hasSetState) {
        this.setState({
            formValues: {...this.state.formValues, [name]: type === "checkbox" ? checked : value},
            formErrors: {...this.state.formErrors, [name]: hasError},
            formValidFields: {...this.state.formValidFields, [name]: !hasError} });
    }
  }

  validateForm = () => {

    let isValid = true;

    const currentFormErrors: IFormErrors = this.state.formErrors;
    const currentValidFields: IFormErrors = this.state.formValidFields;

    Object.keys(currentValidFields).forEach(e => {
        if (!currentValidFields[e as keyof IFormErrors]) {
            isValid = false;
        }

        switch (e) {
            case "alternateFormatDocuments":
            case "requestAlternateFormatTypes":
                if (this.state.formValues.feedbackSubject === "Request_alternate_format" && this.state.formValues[e].length === 0) {
                    isValid = false;
                    currentFormErrors[e] = true;
                }
              break;
            case "brailleFormatType":
                if (this.state.formValues.feedbackSubject === "Request_alternate_format" && this.state.formValues.requestAlternateFormatTypes === "Braille" && this.state.formValues[e].length === 0) {
                        isValid = false;
                        currentFormErrors[e] = true;
                    }
                break;
            case "electronicFormatType":
                if (this.state.formValues.feedbackSubject === "Request_alternate_format" && this.state.formValues.requestAlternateFormatTypes === "Electronic" && this.state.formValues[e].length === 0) {
                    isValid = false;
                    currentFormErrors[e] = true;
                }
              break;
            case "audioFormatType":
            case "audioDeliveryType":
                if (this.state.formValues.feedbackSubject === "Request_alternate_format" && this.state.formValues.requestAlternateFormatTypes === "Audio" && this.state.formValues[e].length === 0) {
                    isValid = false;
                    currentFormErrors[e] = true;
                }
              break;
            case "otherFormatType":
              if (this.state.formValues.feedbackSubject === "Request_alternate_format" && this.state.formValues.requestAlternateFormatTypes === "Other" && this.state.formValues[e].length === 0) {
                  isValid = false;
                  currentFormErrors[e] = true;
              }
            break;
            default:
                currentFormErrors[e as keyof IFormErrors] = !currentValidFields[e as keyof IFormErrors];
              break;
          }
    });

    this.setState({...this.state, formErrors: currentFormErrors });

    return isValid;
  }

  handleSubmit = (e: any) => {
    e.preventDefault();

    const isValid = this.validateForm();
    if (isValid) {
        if (this.props.isRecaptchaOn) {
            if (!this.state.isRecaptchaEnterpriseHighRisk) {
                const clientId = (this.props.recaptchaClientId === undefined) ? 0 : this.props.recaptchaClientId;
                this.processCaptcha(clientId);
            }
            else if (this.state.isRecaptchaV2Rendered) {
                if (this.state.isVerified) {
                    this.sendData();
                }
            }
        }
        else  {
            this.sendData();
        }
    }
    else {
        this.focusFirstError();

        if (this.props.isDebugMode) {
            console.log(this.state);
        }
    }
  }

  processCaptcha = (clientId: any) => {
    if (this.props.isDebugMode) {
        console.log("process enterprise recaptcha");
    }

    grecaptcha.enterprise.ready(() => this.grecaptchaReady(clientId));
  }

  grecaptchaReady = (clientId: any) => {
    if (this.props.isDebugMode) {
        console.log("enterprise recaptcha ready");
        console.log(clientId);
    }

    const actionName = "ValidateCaptchaEnterprise";
    grecaptcha.enterprise.execute(clientId, { action: actionName }).then((token: any) => this.grecaptchaExecuteCallBack(token));
  }

  grecaptchaExecuteCallBack = (token: any) => {
    return new Promise((resolve, reject) => {
        const actionName = "ValidateCaptchaEnterprise";
        this.validateCaptcha(token, actionName, true);

        if (this.props.isDebugMode) {
            console.log("enterprise recaptcha validated");
        }
    });
  }

  validateCaptcha = (token: any, actionName: any, isScore: any) => {
    if (this.props.isDebugMode) {
        console.log("validating enterprise recaptcha");
    }

    const url = this.props.recaptchaValidationUrl;
    if (typeof setCaptchaToken === "function") {
        setCaptchaToken(token);
    }

    let options;
    const params = { captcha: token, action: actionName, isScore: isScore };

    options = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(params)
    };

    fetch(url, options)
    .then(response => response.json())
    .then(data => {
        if (this.props.isDebugMode) {
            console.log(data);
        }

        this.successCaptcha(data);
    })
    .catch(error => {
        if (this.props.isDebugMode) {
            console.log("captcha validation failed: " + error.toString());
        }
    });
  }

  successCaptcha = (data: any) => {
    if (typeof setCheckV2HighRisk === "function") {
        setCheckV2HighRisk(data.highRisk);
    }

    if (data.highRisk === undefined) {
        if (this.props.isDebugMode) {
            console.log("highRisk undefined");
        }
        if (typeof setCheckV2HighRisk === "function") {
            setCheckV2HighRisk("True");
        }
        this.sendData();
    } else if (data.highRisk.toLowerCase() === "false") {
        this.sendData();
    } else {
        if (!this.state.isRecaptchaV2Rendered) {
            this.setState({...this.state, isRecaptchaEnterpriseHighRisk: true, isRecaptchaV2Rendered: true }, () => {
                this.enableReCaptchaV2();
                if (this.props.isDebugMode) {
                    console.log("recaptchaV2 enabled");
                }
            });
        }
        else if (this.state.isVerified) {
            this.sendData();
        }
    }
  }

  enableReCaptchaV2 = () => {
    grecaptcha.enterprise.ready(() => { this.grecaptchaReadyV2(); });
  }

  grecaptchaReadyV2 = () => {
    const captchaId = grecaptcha.enterprise.render("V2Captcha", {
        "badge": "inline",
        "sitekey": this.props.siteKey,
        "callback": this.successCaptchaCallbackV2,
        "expired-callback": this.expCallback
    });

    if (typeof setCaptchaId === "function") {
        setCaptchaId(captchaId);
    }
  }

  successCaptchaCallbackV2 = (token: any) => {
    if (typeof setCaptchaToken === "function") {
        setCaptchaToken(token);
    }
    if (typeof setCheckV2HighRisk === "function") {
        setCheckV2HighRisk("True");
    }

    this.setState({...this.state, isVerified: true}, () => { this.sendData(); });
  }

  expCallback = () => {
    this.setState({...this.state, isVerified: false}, () => { grecaptcha.enterprise.reset(); });
  }

  showForm = () => {
    this.setState({...this.state, formValues: this.initFormValues, feedbackSubmitSuccess: false, feedbackSubmitFailure: false, isVerified: false, isSubmitting: false, isRecaptchaEnterpriseHighRisk: false, isRecaptchaV2Rendered: false},
        () => { if (typeof toggleBackButton === "function") {
                toggleBackButton(true);
            }
        }
      );
  }

  errorClass = (error: any) => {
    return(error ? "has-error" : "");
  }

  sendData = async () => {
    this.setState({...this.state, isSubmitting: true });
    const url = this.props.url;
    const token = this.props.token;
    const formData = await getFeedbackData(this.props.intl, this.props.lang, this.props.isProd, this.props.localizationUrl, this.state.formValues);

    let preferredLang = this.props.lang.toLowerCase() === "en" ? "en-us" : "fr";
    if (this.state.formValues.contactMethod !== "None") {
        preferredLang = this.state.formValues.preferredLanguage === "English" ? "en-us" : "fr";
    }

    if (this.props.isDebugMode) {
        console.log(formData);
    }

    fetch(url, {
        method: "post",
        headers: {"Content-Type": "application/json; charset=UTF-8", "preferred-lang": preferredLang, "Authorization": `Bearer ${token}`},
        body: JSON.stringify(formData)
    })
    .then(response => {
        if (response.status === 200 || response.status === 201) {
            if (this.props.isDebugMode) {
                console.log("Success" + response);
            }
            this.setState({...this.state, feedbackSubmitSuccess: true, isSubmitting: false, isRecaptchaEnterpriseHighRisk: false },
                () => { if (typeof toggleBackButton === "function") {
                        toggleBackButton(false);
                    }
                }
            );
        } else {
            if (this.props.isDebugMode) {
                console.log("Failed" + response);
            }
            this.setState({...this.state, feedbackSubmitSuccess: false, feedbackSubmitFailure: true, isSubmitting: false },
                () => { if (typeof scrollToTop === "function") {
                        scrollToTop();
                    }
                }
            );
        }
    })
    .catch(error => {
        if (this.props.isDebugMode) {
            console.log("Error" + error);
        }
        this.setState({...this.state, feedbackSubmitSuccess: false, feedbackSubmitFailure: true, isSubmitting: false },
            () => { if (typeof scrollToTop === "function") {
                    scrollToTop();
                }
            }
        );
    });
  }

  focusFirstError = () => {
    let isFirstError = true;
    Object.keys(this.state.formErrors).map((fieldName, i) => {
        if (isFirstError && this.state.formErrors[fieldName as keyof IFormErrors] === true) {
            this.setFocus(fieldName);
            isFirstError = false;
        }
    });
  }

  setFocus = (fieldName: string) => {
    switch (fieldName) {
        case "feedbackSubject":
            this.feedbackSubjectRef.current?.focus();
            break;
        case "comments":
            this.commentsRef.current?.focus();
            break;
        case "emailAdd":
            this.emailAddRef.current?.focus();
            break;
        case "telephone":
            this.telephoneRef.current?.focus();
            break;
        case "ipRelay":
            this.ipRelayRef.current?.focus();
            break;
        case "ttyNumber":
            this.ttyNumberRef.current?.focus();
            break;
        case "videoRelayService":
            this.videoRelayServiceRef.current?.focus();
            break;
        case "alternateFormatDocuments":
            this.alternateFormatDocumentsRef.current?.focus();
            break;
        case "requestAlternateFormatTypes":
            this.requestAlternateFormatTypesRef.current?.focus();
            break;
        case "brailleFormatType":
            this.brailleFormatTypeRef.current?.focus();
            break;
        case "electronicFormatType":
            this.electronicFormatTypeRef.current?.focus();
            break;
        case "audioFormatType":
            this.audioFormatTypeRef.current?.focus();
            break;
        case "audioDeliveryType":
            this.audioDeliveryTypeRef.current?.focus();
            break;
        case "otherFormatType":
            this.otherFormatTypeRef.current?.focus();
            break;
        case "RAF_fullName":
            this.RAF_fullNameRef.current?.focus();
            break;
        case "RAF_email":
            this.RAF_emailRef.current?.focus();
            break;
        case "RAF_telephone":
            this.RAF_telephoneRef.current?.focus();
            break;
        case "RAF_streetAdd":
            this.RAF_streetAddRef.current?.focus();
            break;
        case "RAF_city":
            this.RAF_cityRef.current?.focus();
            break;
        case "RAF_province":
            this.RAF_provinceRef.current?.focus();
            break;
        case "RAF_country":
            this.RAF_countryRef.current?.focus();
            break;
        case "RAF_postalCode":
            this.RAF_postalCodeRef.current?.focus();
            break;
        default:
            break;
    }
  }

  render() {

    const refs = { feedbackSubjectRef : this.feedbackSubjectRef, commentsRef : this.commentsRef, alternateFormatDocumentsRef: this.alternateFormatDocumentsRef, requestAlternateFormatTypesRef : this.requestAlternateFormatTypesRef, brailleFormatTypeRef : this.brailleFormatTypeRef, electronicFormatTypeRef : this.electronicFormatTypeRef, audioFormatTypeRef : this.audioFormatTypeRef, audioDeliveryTypeRef : this.audioDeliveryTypeRef,
        otherFormatTypeRef : this.otherFormatTypeRef, RAF_fullNameRef : this.RAF_fullNameRef, RAF_emailRef : this.RAF_emailRef, RAF_telephoneRef : this.RAF_telephoneRef, RAF_streetAddRef : this.RAF_streetAddRef, RAF_cityRef : this.RAF_cityRef, RAF_provinceRef : this.RAF_provinceRef, RAF_countryRef : this.RAF_countryRef, RAF_postalCodeRef : this.RAF_postalCodeRef,
        emailAddRef : this.emailAddRef, telephoneRef : this.telephoneRef, ipRelayRef : this.ipRelayRef, ttyNumberRef : this.ttyNumberRef, videoRelayServiceRef : this.videoRelayServiceRef, tooltipInstance : this.tooltipInstance };
    const methods = { handleChange : this.handleChange, handleBlur : this.handleBlur, errorClass : this.errorClass, setFocus : this.setFocus, setTooltipInstance : this.setTooltipInstance };

    return (
        <div>
            <form name="Feedback" id="Feedback" aria-labelledby="feedback_form_desc" onSubmit={this.handleSubmit}>
            {(this.props.brandStyle.toLowerCase() === "bell" || this.props.brandStyle.toLowerCase() === "bce") &&
                <FeedbackFormBell  {...this.state} {...this.props} {...refs} {...methods} ></FeedbackFormBell>
            }
            {(this.props.brandStyle.toLowerCase() === "lucky") &&
                <FeedbackFormLucky  {...this.state} {...this.props} {...refs} {...methods} ></FeedbackFormLucky>
            }
            </form>
        </div>
    );
  }
}

export default injectIntl(FeedbackForm);
